export const DEVICE = {
  web: 'Web',
  android: 'Android',
  ios: 'IOS'
}
